/**************************************************
 * Nombre:       Tarjeta_Blog_Mini
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Chip, Grid, Typography} from "@mui/material";
import {COLORTEXTO} from "../../Constantes";
import {CalendarMonth} from '@mui/icons-material'
import {useNavigate} from "react-router";
import {theme} from "../../Tema";
import dayjs from "dayjs";


const Tarjeta_Blog_Mini = ({item}) => {
    const navigate = useNavigate();

    return (
        <Grid
            onClick={() => navigate('/Blog/' + item.id)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={1}
            sx={{cursor: 'pointer'}}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 4, sm: 4, md: 4}}
                sx={{
                    backgroundImage: 'url(' + item.img + ')',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: 70,
                }}
            >


            </Grid>

            <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14, mt: -1, color: '#00000080'}}>
                    <span>
                       <CalendarMonth sx={{fill: theme.palette.primary.main, mt: 0.8, mb: -0.8, mr: 0.5}}/>
                    </span>

                            {dayjs(item.fechaPublicacion).format('MMMM DD, YYYY')}
                        </Typography>

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: 14,
                                lineHeight: 1.2,
                                textOverflow: "ellipsis",
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2
                            }}>
                            {item.nombre}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Blog_Mini